import React from 'react'
import { any, bool, func } from 'prop-types'
import styled from 'styled-components'

import { useFormCanSubmit } from '../../hooks/useFormCanSubmit'
import { useFormContext } from '../Form'
import { Button } from '../Button'

const StyledButton = styled(Button)(
  ({ theme }) => `
    border-color: ${theme.lightBlue};
    background-color: ${theme.lightBlue};
    color: ${theme.isDark ? theme.darkGrey : theme.darkTextColor};
    width: 100%;
    font-weight: bold;
`
)

export const SubmitButton = ({ onClick, children, checkCaptcha, ...rest }) => {
  const context = useFormContext()
  const canSubmit = useFormCanSubmit()
  const disabled = !canSubmit || (checkCaptcha && !context?.values?.captcha)

  return (
    <StyledButton type='submit' size='medium' disabled={disabled} onClick={onClick} {...rest}>
      {children}
    </StyledButton>
  )
}

SubmitButton.defaultProps = {
  checkCaptcha: false,
}

SubmitButton.propTypes = {
  children: any,
  onClick: func,
  checkCaptcha: bool,
}
